/** Stored answer when business skips an optional questionnaire question. */
export const OPTIONAL_QUESTION_SKIP_ANSWER = "N/A";

export const isQuestionnaireQuestionOptional = (question) =>
  question?.isRequired === false;

export const isSkippedOptionalAnswer = (answerText) =>
  String(answerText || "")
    .trim()
    .toUpperCase() === OPTIONAL_QUESTION_SKIP_ANSWER;
